// extracted by mini-css-extract-plugin
export default {"DropdownMenu":"dropdownMenu_DropdownMenu__v6+Hk"};